import { getAvailableLendersByLenderCommissions } from '__core/shared/util/salestrekker';
import template from './lenderDocumentLibrary.template.html';

export default {
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $mdMedia,
      $mdDialog,
      $filter,
      $timeout,
      eventService,
      authenticationService,
      organizationService,
      helperService,
      accountService,
      lendersService,
      INSTANCE,
      LENDER
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isAuthenticated = authenticationService.isAuthenticated();
      ctrl.hasBrokerToolsEnabled = false;

      ctrl.initialize = () => {
        ctrl.hasBrokerToolsEnabled = ctrl.isAuthenticated
          ? $rootScope.hasBrokerToolsEnabled()
          : false;

        ctrl.destroyWatch = eventService.onLenderDocumentLibrary((params) => {
          $mdDialog
            .show({
              targetEvent: params?.event || null,
              locals: {},
              template,
              controllerAs: '$ctrl',
              controller() {
                const ctr = this;
                ctr.isReady = false;
                ctr.isProcessing = false;
                ctr.isEnterprise = $rootScope.IsEnterprise;
                ctr.currentAccount = $rootScope.CurrentAccount;
                ctr.currentOrganization = $rootScope.CurrentOrganization;
                ctr.organizationCountry = helperService.getOrganizationCountry().cca2;
                ctr.lenders = [];
                ctr.documents = [];
                ctr.filteredDocuments = [];
                ctr.idLender = '';
                ctr.idType = 'ALL';
                ctr.searchLenderTerm = '';
                ctr.searchTypeTerm = '';
                ctr.availableTypes = _.filter(
                  LENDER.DETAILS.DOCUMENT_TYPES,
                  (d) =>
                    d?.id !== LENDER.DETAILS.DOCUMENT_TYPES[3]?.id &&
                    d?.id !== LENDER.DETAILS.DOCUMENT_TYPES[4]?.id &&
                    d?.id !== LENDER.DETAILS.DOCUMENT_TYPES[6]?.id
                );
                ctr.types = _.map(
                  _.filter(ctr.availableTypes, (t) => t?.id !== 'ALL'),
                  'id'
                );

                $q.all([
                  organizationService.readOrganization({ id: ctr.currentOrganization?.id }),
                  accountService.readAccount({ id: ctr.currentAccount.id }),
                  lendersService.getAvailable({
                    cca2: [ctr.organizationCountry]
                  })
                ]).then((data) => {
                  const organization = data[0];
                  const account = data[1];
                  const lenders = data[2];
                  ctr.isBroker = authenticationService.isBroker(account.id);

                  if (lenders?.length && account?.lenderAccreditations?.length) {
                    const availableLenders = getAvailableLendersByLenderCommissions(
                      lenders,
                      organization,
                      account,
                      null,
                      ctr.isEnterprise
                    );
                    ctr.lenders = _.chain(availableLenders)
                      .sortNatural('name')
                      .sortNatural('group')
                      .value();
                    ctr.isReady = true;
                  } else {
                    ctr.isReady = true;
                  }
                });

                ctr.changeLender = () => {
                  ctr.isProcessing = true;
                  ctr.filteredDocuments = [];
                  lendersService
                    .getDocuments({ idLenders: [ctr.idLender], types: ctr.types })
                    .then((lendersDocuments) => {
                      if (lendersDocuments?.length) {
                        ctr.documents = lendersDocuments;
                        ctr.filteredDocuments = lendersDocuments;
                        ctr.isProcessing = false;
                      } else {
                        ctr.isProcessing = false;
                      }
                    });
                };

                ctr.getLenderWebsite = () => {
                  const currentLender = _.find(ctr.lenders, (l) => l?.id === ctr.idLender);
                  if (!currentLender) {
                    return null;
                  }
                  const emails = _.filter(
                    currentLender?.contact || [],
                    (c) => c?.type === 'WEBSITE'
                  );
                  return emails[0]?.details || null;
                };

                ctr.toggleType = () => {
                  const docs =
                    ctr.idType !== 'ALL'
                      ? _.filter(ctr.documents, (d) => d?.type.indexOf(ctr.idType) > -1)
                      : ctr.documents;
                  ctr.filteredDocuments = docs;
                };

                ctr.clearSearchLenderTerm = () => {
                  ctr.searchLenderTerm = '';
                };

                ctr.clearSearchTypeTerm = () => {
                  ctr.searchTypeTerm = '';
                };

                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then(() => {});
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
